import { toTimestamp } from '../utils/addWebSocketToReplication'
import { toISOString, toISOStringOrNull } from '../utils/pushSafetyUtils'
import { createReplication } from './createReplication'
import type { ChecklistCollection } from '../index'

export const setupChecklistReplication = (
  collection: ChecklistCollection,
  envId: string,
) =>
  createReplication({
    entityName: 'checklists',
    displayName: 'Checklist',
    collection,
    envId,
    mapFromServer: (doc) => ({
      id: doc.id,
      envId: doc.envId,
      taskId: doc.workItemId || doc.taskId,
      title: doc.title || doc.name,
      sortOrder: doc.sortOrder ?? null,
      isDeleted: doc.isDeleted || false,
      createdOn: toTimestamp(doc.createdOn) ?? new Date(doc.createdOn).getTime(),
      createdBy: doc.createdBy,
      updatedOn: toTimestamp(doc.updatedOn) ?? new Date(doc.updatedOn).getTime(),
      updatedBy: doc.updatedBy,
      deletedOn: doc.deletedOn ? (toTimestamp(doc.deletedOn) ?? new Date(doc.deletedOn).getTime()) : null,
      deletedBy: doc.deletedBy,
    }),
    mapToServer: (state, envId) => ({
      id: state.id,
      envId,
      workItemId: state.taskId,
      name: state.title ?? '',
      sortOrder: state.sortOrder ?? null,
      isDeleted: state.isDeleted,
      createdOn: toISOString(state.createdOn),
      createdBy: state.createdBy,
      updatedOn: toISOString(state.updatedOn),
      updatedBy: state.updatedBy,
      deletedOn: toISOStringOrNull(state.deletedOn),
      deletedBy: state.deletedBy,
    }),
  })
